import { useEffect, useState } from 'react';
import { totalCountEvent } from 'services/generalServices';
import { listUsers } from 'services/users/userServices';
import { sortByKey } from 'utils/utils';

export function useFirmUserList(
  is_include_groups = false,
  active_groups = false,
  excludeFromLoading = false,
  is_confirmed_user = true,
  status = 'ACTIVE'
) {
  const [List, setList] = useState([]);
  const [isFirmUserLoading, setIsFirmUserLoading] = useState(false);

  const loadUserList = () => {
    setIsFirmUserLoading(true);
    totalCountEvent('user')
      .then((response) => {
        listUsers({ status: status, limit: response.data, is_confirmed_user, is_include_groups, active_groups, excludeFromLoading })
          .then((response) => {
            const firmUsers = response.data?.firm_users?.filter((user) => user.res_type === 'user') || [];
            const groups = response.data?.firm_users?.filter((user) => user.res_type === 'user-group') || [];
            const sortedFirmUsers = sortByKey(firmUsers, 'first_name');
            const sortedGroups = groups.sort((a, b) =>
              (a.group_name?.toLowerCase() || '').localeCompare(b.group_name?.toLowerCase() || '')
            );
            setList([...sortedFirmUsers, ...sortedGroups]);
          })
          .catch((err) => console.error(err))
          .finally(() => setIsFirmUserLoading(false));
      })
      .catch((error) => {
        setIsFirmUserLoading(false);
        console.warn(error);
      });
  };

  useEffect(() => {
    loadUserList();
  }, []);

  return { userList: List, isFirmUserLoading };
}
